module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "toggle-button",
    class: [_vm.toggleState],
    on: {
      "click": _vm.handleClick
    }
  }, [_c('span', {
    staticClass: "toggle-button__left-label"
  }, [_vm._v(_vm._s(_vm.leftLabel))]), _vm._v(" "), _c('span', {
    staticClass: "toggle-button__right-label"
  }, [_vm._v(_vm._s(_vm.rightLabel))]), _vm._v(" "), _c('span', {
    staticClass: "toggle-button__selection"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e36cbe1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/toggleButton/ToggleButton.vue
// module id = 1932
// module chunks = 0